import TranscoderService, { ITranscoderConfig } from '@engoo/transcoder-service';
import clientConfigs from 'app/config/client';

type Config = { host: string } & Partial<ITranscoderConfig>;

export const createTranscoderService = (config: Config = clientConfigs.transcoding) => {
  return new TranscoderService(config);
};
